<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
document.addEventListener("DOMContentLoaded", function () {
    const navItems = document.querySelectorAll('.custom-main-menu li.menu-item');

    navItems.forEach(item => {
        // Add event listener for hover
        item.addEventListener('mouseover', function () {
            document.body.classList.add('hover-active'); 
        });

        // Remove hover effect when mouse leaves
        item.addEventListener('mouseout', function () {
            document.body.classList.remove('hover-active'); 
        });
    });
});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
